package one.primehealth.app

/**
 * Determines the application flavour from BuildKonfig constant.
 *
 * @param buildFlavour The BUILD_FLAVOUR constant from BuildKonfig
 * @return Corresponding Flavour enum value
 */
fun detectFlavour(buildFlavour: String): Flavour {
    return when (buildFlavour) {
        "Prod" -> Flavour.Prod
        "PreProd" -> Flavour.Prod
        "Stage" -> Flavour.Stage
        else -> Flavour.Stage
    }
}

